import React, { useEffect } from 'react'
import { connect } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import { NavgationPageLocationKey, STANDARD_FORMATS } from '../../../utils/constants';
import { Button, Card, Col, Container, DatePicker, Form, FormInput, FormSelect, ListGroup, ListGroupItem, Row } from 'shards-react';
import StandardFormInputFreeWidth from '../../../components/common/StandardFormInputFreeWidth';
import { useState } from 'react';
import { calculateTimeDifference, setAPIDate, setDateForTable, setInputDate } from '../../../utils/date';
import { get_client_timesheet_hours, reset_client_timesheet_hour_details, save_client_timesheet_hours } from '../../../redux/actions/client/clientTimesheet';
import { prepareHourMinutesOptions } from '../../../utils/general';

const AddEditClientHour = ({ save_client_timesheet_hours, get_client_timesheet_hours
    , timesheetHourDetail, reset_client_timesheet_hour_details
 }) => {

    const location = useLocation();
    const [refNum, setRefNum] = useState(0);
    const [timesheetId, setTimesheetId] = useState(0);
    const [timesheetInfo, setTimesheetInfo] = useState({});
    const history = useHistory()

    const [initialState, setInitialState] = useState({
        refNum: refNum,
        timesheetRefNum: timesheetId,
        date: '',
        description: '',
        //Missing in API
        client: '',
        worker: '',
        payPeriodEndDate: '',
        status: '',

        regularTimeFrom: '',
        regularTimeFromHH: '',
        regularTimeFromMM: '',
        regularTimeTo: '',
        regularTimeToHH: '',
        regularTimeToMM: '',
        regularHours: '',

        overtimeTimeFrom: '',
        overtimeTimeFromHH: '',
        overtimeTimeFromMM: '',
        overtimeTimeTo: '',
        overtimeTimeToHH: '',
        overtimeTimeToMM: '',
        overTimeHours: '',// overTimeHours in API
        
        ptoTimeFrom: '',
        ptoTimeFromHH: '',
        ptoTimeFromMM: '',
        ptoTimeTo: '',
        ptoTimeToHH: '',
        ptoTimeToMM: '',
        ptoHours: '',
    })

    const [formData, setFormData] = useState(initialState)
    const onChange = (e) => setFormData({ ...formData, [e.target.name]: e.target.value });

    const onChangeStandardInput = (name, value) => {
        setFormData({ ...formData, [name]: value });
    };

    const onCancel = () => {
        history.push({ pathname: `/add-edit-cli-timesheet`, state: { refNum: timesheetId.split('-')[1] } });
    }

    const onSubmit = async (e) => {
        e.preventDefault();
        let dataToSave = prepareSavingObject();

        if(Object.keys(dataToSave).length === 0)
            return false;

        let saved = await save_client_timesheet_hours(dataToSave)
        if (saved)
            onCancel();
    }

    const checkForFormulaCalculation = () => {
        let regular = 0;
        let overTime = 0;
        let pto = 0;

        let overtimeToHH = formData.overtimeTimeToHH;
        let regularToHH = formData.regularTimeToHH;
        let ptoToHH = formData.ptoTimeToHH;

        let resetRegularTo = false;
        let resetptoTimeTo = false;
        let resetoverTimeTo = false;
        if (formData.regularTimeFrom != "" && formData.regularTimeTo != "") {
            if(Number(formData.regularTimeFromHH) > Number(formData.regularTimeToHH)){
                resetRegularTo = true;
            }
            else {
                regular = timesheetHourDetail?.regularTimeFrom === "00:00" && timesheetHourDetail?.regularTimeTo === "00:00"
                    ? formData.regularHours : calculateTimeDifference(formData.regularTimeFrom, formData.regularTimeTo);
            }
        }        
        else {
            regular = timesheetHourDetail?.regularHours;
        }

        if (formData.overtimeTimeFrom != "" && formData.overtimeTimeTo != "") {
            if(Number(formData.overtimeTimeFromHH) > Number(formData.overtimeTimeToHH)){
                resetoverTimeTo = true;
            }
            else {
                overTime = timesheetHourDetail?.overtimeTimeFrom === "00:00" && timesheetHourDetail?.overtimeTimeTo === "00:00"
                    ? formData.overTimeHours : calculateTimeDifference(formData.overtimeTimeFrom, formData.overtimeTimeTo);
            }
        }
        else {
            overTime = timesheetHourDetail?.overTimeHours;
        }

        if (formData.ptoTimeFrom != "" && formData.ptoTimeTo != "") {
            if(Number(formData.ptoTimeFromHH) > Number(formData.ptoTimeToHH)){
                resetptoTimeTo = true;
            }
            else {
                pto = timesheetHourDetail?.ptoTimeFrom === "00:00" && timesheetHourDetail?.ptoTimeTo === "00:00" 
                    ? formData.ptoHours : calculateTimeDifference(formData.ptoTimeFrom, formData.ptoTimeTo);
            }
        }
        else {
            pto = timesheetHourDetail?.ptoHours;
        }

        setFormData({
            ...formData
            , regularHours: resetRegularTo ? '00' : regular
            , regularTimeToHH: resetRegularTo ? '00' : regularToHH
            , regularTimeToMM: resetRegularTo ? '00' : formData.regularTimeToMM
            
            , overTimeHours: resetoverTimeTo ? '00' : overTime
            , overtimeTimeToHH: resetoverTimeTo ? '00' : overtimeToHH
            , overtimeTimeToMM: resetoverTimeTo ? '00' : formData.overtimeTimeToMM
            
            , ptoHours: resetptoTimeTo ? '00' : pto
            , ptoTimeToHH: resetptoTimeTo ? '00' : ptoToHH
            , ptoTimeToMM: resetptoTimeTo ? '00' : formData.ptoTimeToMM
        });
    }

    const prepareSavingObject = () => {
        let data = {...formData};
        data.payPeriodEndDate = setInputDate(data.payPeriodEndDate);
        data.date = setInputDate(data.date);
        data.description = data.description.trim();
        data.timesheetRefNum = data.timesheetRefNum.split('-')[1];
        return data;
    }

    useEffect(() => {
        if (refNum === 0) {
            if (location.state !== undefined) {
                //Take from state --> Also Add screnario will fall here
                let itemId = location.state.refNum;
                let timesheetId = location.state.timesheetId;
                let information = location.state.timesheetInfo;
                setRefNum(itemId);
                setTimesheetId(timesheetId);
                setTimesheetInfo(information);

                if (Number(itemId) !== 0 && timesheetId !== "") {
                    get_client_timesheet_hours(timesheetId.split('-')[1], itemId);
                }

            }
            else if (localStorage.getItem(NavgationPageLocationKey.TimesheetCurrentAddEdit) !== null
                && localStorage.getItem(NavgationPageLocationKey.TimesheetCurrentHoursAddEdit) !== null
                && localStorage.getItem(NavgationPageLocationKey.TimesheetCurrentHoursInformation) !== null
            ) {
                //Take from local storage 
                let storageRefNum = localStorage.getItem(NavgationPageLocationKey.TimesheetCurrentAddEdit);
                let storageTimesheetRefNum = localStorage.getItem(NavgationPageLocationKey.TimesheetCurrentHoursAddEdit);
                let storageTimesheetInformation = localStorage.getItem(NavgationPageLocationKey.TimesheetCurrentHoursInformation);
                setRefNum(storageRefNum);
                setTimesheetId(storageTimesheetRefNum);
                get_client_timesheet_hours(storageTimesheetRefNum.split('-')[1], storageRefNum);
                //Set state for same page
                const newState = { refNum: storageRefNum
                    , timesheetId: storageTimesheetRefNum
                    , timesheetInfo: storageTimesheetInformation
                }
                history.push(location.pathname, newState);
                localStorage.removeItem(NavgationPageLocationKey.TimesheetCurrentAddEdit);
                localStorage.removeItem(NavgationPageLocationKey.TimesheetCurrentHoursAddEdit);
                localStorage.removeItem(NavgationPageLocationKey.TimesheetCurrentHoursInformation);
            }
        }

        return () => {
            reset_client_timesheet_hour_details();
        }
    }, [])

    useEffect(() => {
        checkForFormulaCalculation();
    }, [formData.overtimeTimeFrom, formData.overtimeTimeTo
        , formData.ptoTimeFrom, formData.ptoTimeTo
        , formData.regularTimeFrom, formData.regularTimeTo])

    useEffect(() => {
        if(Object.keys(timesheetHourDetail).length === 0){
            return
        }
        setFormData({ ...formData 
            , description: timesheetHourDetail.description 
            , date: setAPIDate(timesheetHourDetail.date) 
            , regularTimeFrom: timesheetHourDetail.regularTimeFrom 
            , regularTimeTo: timesheetHourDetail.regularTimeTo 
            , regularHours: timesheetHourDetail.regularHours 
            , overtimeTimeFrom: timesheetHourDetail.overtimeTimeFrom 
            , overtimeTimeTo: timesheetHourDetail.overtimeTimeTo 
            , overTimeHours: timesheetHourDetail.overTimeHours 
            , ptoTimeFrom: timesheetHourDetail.ptoTimeFrom 
            , ptoTimeTo: timesheetHourDetail.ptoTimeTo 
            , ptoHours: timesheetHourDetail.ptoHours 

            // Dropdown Adjustment
            , regularTimeFromHH: timesheetHourDetail.regularTimeFrom?.split(":")[0]
            , regularTimeFromMM: timesheetHourDetail.regularTimeFrom?.split(":")[1]
            , regularTimeToHH: timesheetHourDetail.regularTimeTo?.split(":")[0]
            , regularTimeToMM: timesheetHourDetail.regularTimeTo?.split(":")[1]

            , overtimeTimeFromHH: timesheetHourDetail.overtimeTimeFrom?.split(":")[0]
            , overtimeTimeFromMM: timesheetHourDetail.overtimeTimeFrom?.split(":")[1]
            , overtimeTimeToHH: timesheetHourDetail.overtimeTimeTo?.split(":")[0]
            , overtimeTimeToMM: timesheetHourDetail.overtimeTimeTo?.split(":")[1]
            
            , ptoTimeFromHH: timesheetHourDetail.ptoTimeFrom?.split(":")[0]
            , ptoTimeFromMM: timesheetHourDetail.ptoTimeFrom?.split(":")[1]
            , ptoTimeToHH: timesheetHourDetail.ptoTimeTo?.split(":")[0]
            , ptoTimeToMM: timesheetHourDetail.ptoTimeTo?.split(":")[1]
        });
    }, [timesheetHourDetail])

    useEffect(() => {
        if(Object.keys(timesheetInfo).length === 0)
            return;

        setFormData({
            ...formData
            , timesheetRefNum: timesheetId
            , refNum: refNum
            , client: String(timesheetInfo.client)
            , worker: String(timesheetInfo.worker)
            , status: timesheetInfo.status
            , payPeriodEndDate: timesheetInfo.payPeriodEndDate
        })
    }, [timesheetInfo])

    const onTimeDropDownChange = (e) => {
        //TODO -> Need to optimize
        adjustValuesSelection(e, "regularTimeFrom", "regularTimeFromHH", "regularTimeFromMM");
        adjustValuesSelection(e, "regularTimeTo", "regularTimeToHH", "regularTimeToMM");

        adjustValuesSelection(e, "overtimeTimeFrom", "overtimeTimeFromHH", "overtimeTimeFromMM");
        adjustValuesSelection(e, "overtimeTimeTo", "overtimeTimeToHH", "overtimeTimeToMM");

        adjustValuesSelection(e, "ptoTimeFrom", "ptoTimeFromHH", "ptoTimeFromMM");
        adjustValuesSelection(e, "ptoTimeTo", "ptoTimeToHH", "ptoTimeToMM");
    }

    const adjustValuesSelection = (e, prop, propHH, propMM) => {
        if(e.target.name.includes(propMM)){
            if(formData[propHH] !== ''){
                setFormData({ ...formData
                    , [prop]: formData[propHH] + ":" + e.target.value
                    , [propMM]: e.target.value
                })
            }
            else {
                setFormData({ ...formData, [e.target.name]: e.target.value });
            }
        }
        else if(e.target.name.includes(propHH)){
            if(formData[propMM] !== ''){
                setFormData({ ...formData
                    , [prop]: e.target.value + ":" + formData[propMM]
                    , [propHH]: e.target.value
                })
            }
            else {
                setFormData({ ...formData, [e.target.name]: e.target.value });
            }
        }
    }

    return (
        <>
            <Container fluid className="main-content-container p-4">
                <Form onSubmit={onSubmit}>
                    <Card small className="mb-4 w-100 ">
                        <ListGroup flush>
                            <ListGroupItem className="border-card p-3">
                                <Row className="">
                                    <Col lg="2" className="form-group m-0 p-2">
                                        <Row>
                                            <Col lg="12" className="form-group">
                                                <Row className="ml-1">
                                                    <Col lg="3" className="form-group my-auto pt-2 pr-1 pl-1">
                                                        <label htmlFor="clientId" className="">Client:</label>

                                                    </Col>
                                                    <Col lg="9" className="form-group my-auto pt-2 pr-1 pl-2">
                                                        <label className="">{formData.client}</label>
                                                    </Col>
                                                </Row>
                                            </Col>
                                        </Row>
                                    </Col>

                                    <Col lg="3" className="form-group m-0 p-2">
                                        <Row>
                                            <Col lg="12" className="form-group pr-2 pl-2">
                                                <Row className="ml-1">
                                                    <Col lg="2" className="form-group my-auto pt-2 pr-1 pl-1">
                                                        <label htmlFor="clientId" className="">Worker:</label>

                                                    </Col>
                                                    <Col lg="10" className="form-group my-auto pt-2 pr-1 pl-2">
                                                        <label className=""> {formData.worker}</label>
                                                    </Col>
                                                </Row>
                                            </Col>
                                        </Row>
                                    </Col>

                                    <Col lg="3" className="form-group m-0 p-2">
                                        <Row>
                                            <Col lg="12" className="form-group pr-2 pl-2">
                                                <Row className="ml-1">
                                                    <Col lg="6" className="form-group my-auto pt-2 pr-1 pl-1">
                                                        <label htmlFor="clientId" className="">Pay Period End Date :</label>

                                                    </Col>
                                                    <Col lg="6" className="form-group my-auto pt-2 pr-1 pl-1">
                                                        <label className="">{setDateForTable(formData.payPeriodEndDate)}</label>
                                                    </Col>
                                                </Row>
                                            </Col>
                                        </Row>
                                    </Col>

                                    <Col lg="2" className="form-group m-0 p-2">
                                        <Row>
                                            <Col lg="12" className="form-group pr-2 pl-2">
                                                <Row className="ml-1">
                                                    <Col lg="4" className="form-group my-auto pt-2 pr-1 pl-1">
                                                        <label htmlFor="clientId" className="">Status :</label>

                                                    </Col>
                                                    <Col lg="8" className="form-group my-auto pt-2 pr-1 pl-1">
                                                        <label className="">{formData.status}</label>
                                                    </Col>
                                                </Row>
                                            </Col>
                                        </Row>
                                    </Col>

                                    <Col lg="2" className="form-group m-0 p-2">
                                        <Row>
                                            <Col lg="12" className="form-group pr-2 pl-2">
                                                <Row className="ml-1">
                                                    <Col lg="6" className="form-group my-auto pt-2 pr-1 pl-1">
                                                        <label htmlFor="clientId" className="">Timesheet # :</label>

                                                    </Col>
                                                    <Col lg="6" className="form-group my-auto pt-2 pr-1 pl-1">
                                                        <label className="">{formData.timesheetRefNum != '0' ? formData.timesheetRefNum : 'New'}</label>
                                                    </Col>
                                                </Row>
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                                <Row className="mb-3">
                                    <Col lg="4" className="form-group m-0 p-2">
                                        <Row>
                                            <Col lg="12" className="form-group">
                                                <Row className="">
                                                    <Col lg="3" className="form-group my-auto pt-2 pr-2 pl-4">
                                                        <label htmlFor="invoiceDate" className="">Date</label>
                                                        <span aria-hidden="true" className="required "> *</span>
                                                    </Col>
                                                    <Col lg="9" className="form-group my-auto">
                                                        <DatePicker
                                                            id='date'
                                                            autoComplete='off'
                                                            name='date'
                                                            dateFormat='yyyy-MM-dd'
                                                            value={formData.date}
                                                            selected={formData.date}
                                                            required
                                                            onChange={(date) =>
                                                                setFormData({ ...formData, 'date': date })
                                                            }
                                                            placeholderText="YYYY-MM-DD"
                                                        />
                                                    </Col>
                                                </Row>
                                            </Col>
                                        </Row>
                                    </Col>
                                    <Col lg="8" className="form-group m-0 p-2">
                                        <Row>
                                            <Col lg="12" className="form-group pr-2 pl-2 pr-2">
                                                <Row className="">
                                                    <Col lg="2" className="form-group my-auto pt-2 pr-0 ml-3">
                                                        <label htmlFor="invoiceDate" className="">Description</label>
                                                    </Col>
                                                    <Col lg="9" className="form-group my-auto">
                                                        <FormInput
                                                            id="description"
                                                            name="description"
                                                            value={formData.description}
                                                            onChange={onChange}
                                                            placeholder="Enter Description"
                                                        />
                                                    </Col>
                                                </Row>
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                                <Row className="mb-3">
                                    <Col lg="4" className="pr-2">
                                        <Card small className="mb-2 w-100 ">
                                            <ListGroup flush>
                                                <ListGroupItem className="p-3">
                                                    <Row>
                                                        <Col lg="12" className={"form-group"}>
                                                            <label>Regular Hours</label>
                                                        </Col>
                                                    </Row>
                                                    <Row>
                                                        <Col className={"form-group mt-1"}>
                                                            <Row form style={{ height: "80px", overflow: "auto" }}>
                                                                <Col lg="5">
                                                                    <div className="d-flex flex-row justify-content-between">
                                                                        <label>From </label>
                                                                    </div>
                                                                    <div className="d-flex flex-row justify-content-between">
                                                                        <FormSelect value={formData.regularTimeFromHH} id="regularTimeFromHH"
                                                                            name='regularTimeFromHH' onChange={onTimeDropDownChange} className=''>
                                                                            <option value=''>HH</option>
                                                                            {prepareHourMinutesOptions(24, '', false)}
                                                                        </FormSelect>
                                                                        <FormSelect value={formData.regularTimeFromMM} id="regularTimeFromMM"
                                                                            name='regularTimeFromMM' onChange={onTimeDropDownChange} className=''>
                                                                            <option value=''>MM</option>
                                                                            {prepareHourMinutesOptions(60, formData.regularTimeToHH === formData.regularTimeFromHH ? formData.regularTimeToMM : '', false)}
                                                                        </FormSelect>
                                                                    </div>
                                                                </Col>
                                                                <Col lg="5">
                                                                    <div className="d-flex flex-row justify-content-between">
                                                                        <label>To </label>
                                                                    </div>
                                                                    <div className="d-flex flex-row justify-content-between">
                                                                        <FormSelect value={formData.regularTimeToHH} id="regularTimeToHH"
                                                                            name='regularTimeToHH' onChange={onTimeDropDownChange} className=''>
                                                                            <option value=''>HH</option>
                                                                            {prepareHourMinutesOptions(24, formData.regularTimeFromHH, true)}
                                                                        </FormSelect>
                                                                        <FormSelect value={formData.regularTimeToMM} id="regularTimeToMM"
                                                                            name='regularTimeToMM' onChange={onTimeDropDownChange} className=''>
                                                                            <option value=''>MM</option>
                                                                            {prepareHourMinutesOptions(60, formData.regularTimeToHH === formData.regularTimeFromHH ? formData.regularTimeFromMM : '', true)}
                                                                        </FormSelect>
                                                                    </div>
                                                                </Col>
                                                                <Col lg="2" className="pr-0">
                                                                    <div className="d-flex flex-row justify-content-between">
                                                                        <label>Hours </label>
                                                                    </div>
                                                                    <div className="d-flex flex-row justify-content-between">
                                                                        <StandardFormInputFreeWidth
                                                                            id="regularHours"
                                                                            name='regularHours'
                                                                            dataMaxFracDigits="2"
                                                                            type="text"
                                                                            placeholder="0.00"
                                                                            standardFormat={STANDARD_FORMATS.COMMA_SEPERATED_NUMBER}
                                                                            onChangeStandardInput={onChangeStandardInput}
                                                                            value={formData.regularHours}
                                                                        />
                                                                    </div>
                                                                </Col>
                                                            </Row>
                                                        </Col>
                                                    </Row>
                                                </ListGroupItem>
                                            </ListGroup>
                                        </Card>
                                    </Col>
                                    <Col lg="4" className="pl-2 pr-2">
                                        <Card small className="mb-2 w-100 ">
                                            <ListGroup flush>
                                                <ListGroupItem className="p-3">
                                                    <Row>
                                                        <Col lg="12" className={"form-group"}>
                                                            <label>Overtime Hours</label>
                                                        </Col>
                                                    </Row>
                                                    <Row>
                                                        <Col className={"form-group mt-1"}>
                                                            <Row form style={{ height: "80px", overflow: "auto" }}>
                                                                <Col lg="5">
                                                                    <div className="d-flex flex-row justify-content-between">
                                                                        <label>From </label>
                                                                    </div>
                                                                    <div className="d-flex flex-row justify-content-between">
                                                                        <FormSelect value={formData.overtimeTimeFromHH} id="overtimeTimeFromHH"
                                                                            name='overtimeTimeFromHH' onChange={onTimeDropDownChange} className=''>
                                                                            <option value=''>HH</option>
                                                                            { prepareHourMinutesOptions(24, '', false) }
                                                                        </FormSelect>
                                                                        <FormSelect value={formData.overtimeTimeFromMM} id="overtimeTimeFromMM"
                                                                            name='overtimeTimeFromMM' onChange={onTimeDropDownChange} className=''>
                                                                            <option value=''>MM</option>
                                                                            { prepareHourMinutesOptions(60, formData.overtimeTimeToHH === formData.overtimeTimeFromHH ? formData.overtimeTimeToMM : '', false) }
                                                                        </FormSelect>
                                                                    </div>
                                                                </Col>
                                                                <Col lg="5">
                                                                    <div className="d-flex flex-row justify-content-between">
                                                                        <label>To </label>
                                                                    </div>
                                                                    <div className="d-flex flex-row justify-content-between">
                                                                        <FormSelect value={formData.overtimeTimeToHH} id="overtimeTimeToHH"
                                                                            name='overtimeTimeToHH' onChange={onTimeDropDownChange} className=''>
                                                                            <option value=''>HH</option>
                                                                            { prepareHourMinutesOptions(24, formData.overtimeTimeFromHH, true) }
                                                                        </FormSelect>
                                                                        <FormSelect value={formData.overtimeTimeToMM} id="overtimeTimeToMM"
                                                                            name='overtimeTimeToMM' onChange={onTimeDropDownChange} className=''>
                                                                            <option value=''>MM</option>
                                                                            { prepareHourMinutesOptions(60, formData.overtimeTimeFromHH === formData.overtimeTimeToHH ? formData.overtimeTimeFromMM : '', true) }
                                                                        </FormSelect>
                                                                    </div>
                                                                </Col>
                                                                <Col lg="2" className="pr-0">
                                                                    <div className="d-flex flex-row justify-content-between">
                                                                        <label>Hours </label>
                                                                    </div>
                                                                    <div className="d-flex flex-row justify-content-between">
                                                                        <StandardFormInputFreeWidth
                                                                            id="overtimeHours"
                                                                            name='overTimeHours'
                                                                            dataMaxFracDigits="2"
                                                                            type="text"
                                                                            placeholder="0.00"
                                                                            standardFormat={STANDARD_FORMATS.COMMA_SEPERATED_NUMBER}
                                                                            onChangeStandardInput={onChangeStandardInput}
                                                                            value={formData.overTimeHours}
                                                                        />
                                                                    </div>
                                                                </Col>
                                                            </Row>
                                                        </Col>
                                                    </Row>
                                                </ListGroupItem>
                                            </ListGroup>
                                        </Card>
                                    </Col>
                                    <Col lg="4" className="pl-2">
                                        <Card small className="mb-2 w-100 ">
                                            <ListGroup flush>
                                                <ListGroupItem className="p-3">
                                                    <Row>
                                                        <Col lg="12" className={"form-group"}>
                                                            <label>PTO Hours</label>
                                                        </Col>
                                                    </Row>
                                                    <Row>
                                                        <Col className={"form-group mt-1"}>
                                                            <Row form style={{ height: "80px", overflow: "auto" }}>
                                                                <Col lg="5">
                                                                    <div className="d-flex flex-row justify-content-between">
                                                                        <label>From </label>
                                                                    </div>
                                                                    <div className="d-flex flex-row justify-content-between">
                                                                        <FormSelect value={formData.ptoTimeFromHH} id="ptoTimeFromHH"
                                                                            name='ptoTimeFromHH' onChange={onTimeDropDownChange} className=''>
                                                                            <option value=''>HH</option>
                                                                            { prepareHourMinutesOptions(24, '', false) }
                                                                        </FormSelect>
                                                                        <FormSelect value={formData.ptoTimeFromMM} id="ptoTimeFromMM"
                                                                            name='ptoTimeFromMM' onChange={onTimeDropDownChange} className=''>
                                                                            <option value=''>MM</option>
                                                                            { prepareHourMinutesOptions(60, formData.ptoTimeToHH === formData.ptoTimeFromHH ? formData.ptoTimeToMM : '', false) }
                                                                        </FormSelect>
                                                                    </div>
                                                                </Col>
                                                                <Col lg="5">
                                                                    <div className="d-flex flex-row justify-content-between">
                                                                        <label>To </label>
                                                                    </div>
                                                                    <div className="d-flex flex-row justify-content-between">
                                                                        <FormSelect value={formData.ptoTimeToHH} id="ptoTimeToHH"
                                                                            name='ptoTimeToHH' onChange={onTimeDropDownChange} className=''>
                                                                            <option value=''>HH</option>
                                                                            { prepareHourMinutesOptions(24, formData.ptoTimeFromHH, true) }
                                                                        </FormSelect>
                                                                        <FormSelect value={formData.ptoTimeToMM} id="ptoTimeToMM"
                                                                            name='ptoTimeToMM' onChange={onTimeDropDownChange} className=''>
                                                                            <option value=''>MM</option>
                                                                            { prepareHourMinutesOptions(60, formData.ptoTimeFromHH === formData.ptoTimeToHH ? formData.ptoTimeFromMM : '', true) }
                                                                        </FormSelect>
                                                                    </div>
                                                                </Col>
                                                                <Col lg="2" className="pr-0">
                                                                    <div className="d-flex flex-row justify-content-between">
                                                                        <label>Hours </label>
                                                                    </div>
                                                                    <div className="d-flex flex-row justify-content-between">
                                                                        <StandardFormInputFreeWidth
                                                                            id="ptoHours"
                                                                            name='ptoHours'
                                                                            dataMaxFracDigits="2"
                                                                            type="text"
                                                                            placeholder="0.00"
                                                                            standardFormat={STANDARD_FORMATS.COMMA_SEPERATED_NUMBER}
                                                                            onChangeStandardInput={onChangeStandardInput}
                                                                            value={formData.ptoHours}
                                                                        />
                                                                    </div>
                                                                </Col>
                                                            </Row>
                                                        </Col>
                                                    </Row>
                                                </ListGroupItem>
                                            </ListGroup>
                                        </Card>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col lg="12" className="d-flex flex-row justify-content-end">
                                        <Button className="mx-1 py-2 mx-md-2" size="sm" theme="accent" name="save">
                                            Save Hours
                                        </Button>
                                        <Button className="mx-1 py-2 mx-md-2" size="sm" theme="accent" name="cancel"
                                            onClick={() => onCancel()}>
                                            Cancel
                                        </Button>
                                    </Col>
                                </Row>
                            </ListGroupItem>
                        </ListGroup>
                    </Card>
                </Form>
            </Container>
        </>
    )
}

const mapStateToProps = (state) => ({
    timesheetHourDetail: state.clientTimesheet.timesheetHourDetail
});
export default connect(mapStateToProps, {
    save_client_timesheet_hours
    , get_client_timesheet_hours
    , reset_client_timesheet_hour_details
})(AddEditClientHour);
